import { getWindowObject, HAS_WINDOW } from '@eventbrite/feature-detection';

export const checkNewBillingSettingsEnabled = (): boolean => {
    if (!HAS_WINDOW) {
        return false;
    }

    const serverData = getWindowObject('__SERVER_DATA__');
    return serverData?.featureFlags?.launchNewBillingSettings || false;
};

export const getOldOrNewFeature = <T, U>(
    oldFeature: T,
    newFeature: U | null | undefined = null,
): T | U => {
    const newBillingSettingsEnabled = checkNewBillingSettingsEnabled();
    return newFeature && newBillingSettingsEnabled ? newFeature : oldFeature;
};
